/** 에러 상태 점멸 효과 — ClearButton/ClearButtonInModal/ImageAvatar/FieldImageItem 등에서 재사용 */
export const errorBlinkKeyframes = `
  @keyframes blinking {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.15;
    }
  }
  animation: blinking 0.6s infinite;
`;

/** 통신 램프 점멸 이름. 위상 동기화 훅이 이 이름만 맞춘다. */
export const statusLedErrorBlinkAnimationName = 'statusLedErrorBlink';

export const statusLedErrorBlinkKeyframesBlock = `
  @keyframes statusLedErrorBlink {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.15;
    }
  }
`;

/** 요소 opacity 애니메이션. delay는 두지 않고 훅이 startTime으로 위상을 맞춘다. */
export const statusLedErrorBlinkAnimation = `
  animation: ${statusLedErrorBlinkAnimationName} 0.6s infinite;
`;

/** StatusCard·DeviceBuiltIn처럼 keyframes를 색 선언 안에 같이 넣을 때 */
export const statusLedErrorBlinkEmbeddedCss = `
  ${statusLedErrorBlinkKeyframesBlock}
  ${statusLedErrorBlinkAnimation}
`;

/**
 * 이미지 아바타 에러 테두리 — location/InspectionDetail/InspectionList/MaintenanceList/MaintenanceDetail 5곳.
 * borderColor: 평시(비-error) 테두리색 — location만 '#8F96A4' 하드코딩, 나머지는 theme.colors.alpha.black[50].
 */
export const imageAvatarStyles = (errorState: any, borderColor: string) => `
  border: ${errorState ? '3' : '1.95'}px solid ${errorState ? 'red' : borderColor};

  ${errorState && errorBlinkKeyframes}
`;
